import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Unsubscriber } from '@core-lib/classes';
import { ActionType } from '@core-lib/enums';
import { IAction } from '@core-lib/models';
import { IOperationRenvoyer } from 'projects/app-front/src/app/alertes-module/models/alertes.model';

@Component({
    selector: 'commentaires-modal',
    templateUrl: './commentaires-modal.component.html',
    styles: [],
    standalone: false
})
export class CommentairesModalComponent extends Unsubscriber {
	@Input() operation: IOperationRenvoyer;
	@Output() action: EventEmitter<IAction> = new EventEmitter();
	userChangeOnForm = false;

	constructor() {
		super();
	}

	getDevise(operation: any): string {
		return operation?.devise?.symbole ?? '€';
	}

	onClose(): void {
		this.action.emit({ type: ActionType.Close });
	}
}
